const DEFAULT_LOGIN_PAGE = {
  layout: 'split',
  cardPosition: 'right',
  theme: 'light',
  backgroundStyle: 'mesh',
  backgroundColor: '#0f172a',
  gradientFrom: '#4f46e5',
  gradientTo: '#0ea5e9',
  gradientAngle: 135,
  fontFamily: 'Inter',
  headingWeight: '800',
  buttonStyle: 'solid',
  buttonRadius: 'default',
  inputStyle: 'default',
  cardRadius: 'large',
  cardStyle: 'elevated',
  showLogo: true,
  showFeatures: true,
  showTagline: true,
  showPoweredBy: true,
  showTopbar: true,
  topbarBackground: 'surface',
  topbarCustomColor: '#ffffff',
  logoSize: 'md',
  features: [],
  slides: [],
  sliderAutoplay: true,
  sliderInterval: 6000,
  sliderTransition: 'fade',
  customCss: '',
};

export default DEFAULT_LOGIN_PAGE;

export function mergeLoginPage(partial) {
  return { ...DEFAULT_LOGIN_PAGE, ...(partial || {}) };
}
